import React from 'react';
import PropTypes from 'prop-types';
import {List, ListItem} from 'material-ui/List';
import Place from 'material-ui/svg-icons/maps/place'
import Terrain from 'material-ui/svg-icons/maps/terrain'
import styles from './OpenExploreModuleBlock.css';
import {white} from 'material-ui/styles/colors';
import ModuleBlock from "../ModuleBlock";
import withTranslation from "../../../../../hoc/withTranslation";
import ModuleService from "../../../../../services/module";

class OpenExploreModuleBlock extends React.Component {

    static propTypes = {
        app: PropTypes.object.isRequired
    };

    render() {
        let content = <List>
            <ListItem
                style={styles.list}
                disabled={true}
                primaryText={this.props.t('module.open_explore.point_count', {count: this.props.app.open_explore_point_count || 0})}
                leftIcon={<Place color={white}/>}/>
            <ListItem
                style={styles.list}
                disabled={true}
                primaryText={this.props.t('module.open_explore.trail_count', {count: this.props.app.open_explore_trail_count || 0})}
                leftIcon={<Terrain color={white}/>}/>
        </List>;

        return (
            <ModuleBlock app={this.props.app} module={ModuleService.getModule(ModuleService.OPEN_EXPLORE)} content={content}/>
        );
    }
}

export default withTranslation(OpenExploreModuleBlock);



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/OpenExploreModuleBlock/OpenExploreModuleBlock.js